import { render, staticRenderFns } from "./21_ap_tipo_operaciones.vue?vue&type=template&id=35b693c0&scoped=true&"
import script from "./21_ap_tipo_operaciones.vue?vue&type=script&lang=js&"
export * from "./21_ap_tipo_operaciones.vue?vue&type=script&lang=js&"
import style0 from "./21_ap_tipo_operaciones.vue?vue&type=style&index=0&id=35b693c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b693c0",
  null
  
)

export default component.exports